import { render, staticRenderFns } from "./repassemedico.vue?vue&type=template&id=4b042916&"
import script from "./repassemedico.vue?vue&type=script&lang=js&"
export * from "./repassemedico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports